import React from 'react';

// Overlay de progresso para salvar a Avaliação 360 — o submit final grava + gera
// o PDF no servidor (Puppeteer) e arquiva no SharePoint, o que leva alguns segundos.
// Barra INDETERMINADA de propósito (o servidor faz tudo numa tacada, sem reportar
// progresso parcial). Cobre a tela e bloqueia novo clique. (Espelha o do BSV, na
// cor do módulo Operacional — ardósia #475569.)
const OverlayProgresso = ({ titulo = 'Processando…', subtitulo }) => (
  <div style={{
    position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(15,23,42,.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
  }}>
    <style>{'@keyframes barraProg{0%{left:-40%}100%{left:100%}}'}</style>
    <div style={{
      background: '#fff', borderRadius: 12, padding: '22px 24px', width: 'min(420px, 92vw)',
      boxShadow: '0 10px 40px rgba(0,0,0,.25)', textAlign: 'center',
    }}>
      <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 16 }}>{titulo}</div>
      {subtitulo && <div style={{ marginTop: 6, fontSize: 13, color: '#64748b' }}>{subtitulo}</div>}
      <div style={{
        marginTop: 16, position: 'relative', height: 8, background: '#e2e8f0',
        borderRadius: 999, overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: 0, height: '100%', width: '40%', borderRadius: 999,
          background: '#475569', animation: 'barraProg 1.1s ease-in-out infinite',
        }} />
      </div>
    </div>
  </div>
);

export default OverlayProgresso;
